'use strict';

var orange$1 = require('../../../../_virtual/orange.js_commonjs-exports.js');

Object.defineProperty(orange$1.__exports, "__esModule", {
  value: true
});
orange$1.__exports.default = void 0;
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var _default = orange;
orange$1.__exports.default = _default;
